import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { FormikTextField } from 'formik-material-fields';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import { productTypeAdditive } from '../../Config/constants'

export default function AdditivesTable(props) {
    const classes = useStyles();
    const [loaded, setLoaded] = useState(false);
    const [rows, setRows] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        var tempRows = [];
        props.productionOrder.bomIn.filter(x => JSON.parse(x.bomMetaData).find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeAdditive).map(m => {
            let productType = JSON.parse(m.bomMetaData).find(y => y.MetaDataType === 1).MetaData[0].ProductType;
            tempRows.push(createData(productType, m.productReference, m.productDescription, m.productId, m.uom));
        });
        // order tempRows by productReference
        tempRows.sort((a, b) => (a.code > b.code) ? 1 : -1)
        setRows(tempRows);
        setLoaded(true);
    }, [props.productionOrder]);

    function createData(type, code, description, id, uom) {
        return { type, code, description, id, uom };
    }

    return (
        <React.Fragment>
            {loaded && rows.length > 0 &&
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}></TableCell>
                            <TableCell className={classes.headCell}></TableCell>
                            <TableCell className={classes.headCell}></TableCell>
                            <TableCell className={classes.headCell}>{t("Barcode")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.name} className={classes.row}>
                                <TableCell className={classes.typeCell}>{t(row.type)}</TableCell>
                                <TableCell className={classes.infoCell}>{row.code}</TableCell>
                                <TableCell className={classes.infoCell}>{row.description}</TableCell>
                                <TableCell className={classes.purchaseNumberCell}>
                                    <FormikTextField id="outlined-search" name={"barcode" + row.id} label="" variant="outlined" onChange={(e) => props.barcodeChanged(e, row.id, row.code)} className={classes.quantityTextField} size="small" />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            }
        </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        paddingLeft: "5px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    typeCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        backgroundColor: "white",
        paddingLeft: "20px",
        width: "20%"
    },
    infoCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "10px",
        paddingRight: "5px",
        paddingLeft: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
        width: "30%"
    },
    quantityCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "10px",
        paddingRight: "5px",
        paddingLeft: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
        width: "20%"
    },
    purchaseNumberCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderRight: "1px solid #DEDEDE",
        borderRadius: " 0 6px 6px 0",
        backgroundColor: "white",
        paddingRight: "10px",
        paddingLeft: "5px",
        width: "20%"
    },
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%",
        marginTop: "30px"
    },
    batchnumberTextField: {
        width: "100%"
    },
    quantityTextField: {
        width: "100%"
    },
    addMaterialAmounts: {
        width: "100%",
        textAlign: "center",
        marginTop: "40px"
    },
}));